import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import {H2, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import GenericModal, {Props as ModalProps} from "@irati/ui/src/GenericModal"
import React from "react"
type Props = Omit<ModalProps, "children">
const PublishErrorModal: React.FC<Props> = (props) => {
  return (
    <GenericModal critical show proceedButtonText="platform.cta.ok" {...props}>
      <Flex direction="column" alignItems="center" gap={mainTheme.spacing.two} marginBottom={4}>
        <H2>
          <FormattedMessage id="recognition.popup.title.alreadyPublished" />
        </H2>
        <Body textAlign="center">
          <FormattedMessage id="recognition.popup.body.alreadyPublished" />
        </Body>
      </Flex>
    </GenericModal>
  )
}

export default PublishErrorModal
